const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// ACOA: "ships from the EU, no customs" trust line on landing pages and product pages
(function () {
  var T = {
    nl: ['Verzonden vanuit de EU · geen douane- of invoerkosten', 'Bestellingen worden verzonden vanuit de EU, dus zonder douane- of invoerkosten.'],
    fr: ["Expédié depuis l'UE · pas de frais de douane ni d'importation", "Les commandes sont expédiées depuis l'UE, sans frais de douane ni d'importation."],
    de: ['Versand aus der EU · keine Zoll- oder Einfuhrgebühren', 'Bestellungen werden aus der EU versendet, ohne Zoll- oder Einfuhrgebühren.'],
    en: ['Ships from the EU · no customs or import fees', 'Orders ship from within the EU, so there are no customs or import fees.']
  };
  function run() {
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var t = T[lang] || T.en;
    var cc = (window.Shopify && Shopify.country) || '';
    if (cc && ['CH', 'GB', 'AE'].indexOf(cc) > -1) return; // non-EU markets: customs may apply
    document.querySelectorAll('ul.trust').forEach(function (ul) {
      if (ul.querySelector('[data-acoa-eu]')) return;
      var li = document.createElement('li');
      li.setAttribute('data-acoa-eu', '1');
      var check = ul.closest('.acoa-lp') ? '✓ ' : '';
      li.textContent = check + t[0];
      ul.appendChild(li);
    });
    document.querySelectorAll('.acoa-lp p.note').forEach(function (p) {
      if (p.getAttribute('data-acoa-eu') || p.textContent.indexOf('Gen') < 0) return;
      p.setAttribute('data-acoa-eu', '1');
      p.appendChild(document.createTextNode(' ' + t[1]));
    });
    if (document.querySelector('[data-acoa-eu-pdp]')) return;
    var leaf = Array.prototype.find.call(document.querySelectorAll('product-info *, .product__info-container *'), function (el) {
      return el.children.length === 0 && /^(Levering|Bezorging|Livraison|Lieferung|Delivery)\b/.test((el.textContent || '').trim());
    });
    if (leaf) {
      var row = leaf.parentElement;
      while (row.parentElement && !row.querySelector('svg,img')) row = row.parentElement;
      var clone = row.cloneNode(true);
      clone.setAttribute('data-acoa-eu-pdp', '1');
      var txt = Array.prototype.find.call(clone.querySelectorAll('*'), function (el) {
        return el.children.length === 0 && /^(Levering|Bezorging|Livraison|Lieferung|Delivery)\b/.test((el.textContent || '').trim());
      });
      if (txt) { txt.textContent = t[0]; row.parentNode.insertBefore(clone, row.nextSibling); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
